export const FR_VAT_RATES = [0, 2.1, 5.5, 10, 20] as const;

export const NO_VAT_FILTER_KEY = '__no_vat__';

export const isSameVatRate = (a: number, b: number): boolean =>
  Math.round(a * 100) === Math.round(b * 100);
